export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7985.784d7911.jpg";